export const ARTICLES = [
  {
    slug: "campana-2026-27-calendario",
    tag: "Calendario",
    date: "NOV 2026",
    title: "Campaña 2026–27: cuándo aplicar cada cultivo en Santa Cruz",
    meta: "Calendario de aplicación por cultivo para la campaña de verano 2026–27 en Santa Cruz: roya en soya, cogollero en maíz y sorgo, madurante en caña y protección de floración en girasol.",
    intro:
      "En aplicación agrícola no gana el que más producto echa: gana el que aplica en la ventana justa. Este es el calendario que manejamos en Santa Cruz para la campaña 2026–27, cultivo por cultivo.",
    sections: [
      {
        heading: "La campaña se gana en el calendario",
        body: [
          "Una plaga no avisa con dos semanas. La roya asiática puede pasar de una mancha en el envés a un lote comprometido en días, y el gusano cogollero tiene una ventana de control que se mide en horas, no en semanas. Por eso la pregunta correcta no es “¿cuánto cuesta aplicar?” sino “¿qué tan rápido pueden estar en mi lote cuando yo avise?”.",
          "Con dron, la espera en zonas activas es de 24 a 72 horas. Eso cambia la planificación: en vez de reservar equipo con semanas de cola, monitoreás el lote y llamás cuando el umbral lo pide.",
        ],
      },
      {
        heading: "Soya: la roya no espera (diciembre a marzo)",
        body: [
          "La roya asiática entra fuerte con las lluvias de verano. El monitoreo empieza desde inicio de floración (R1) y las aplicaciones preventivas o curativas se concentran entre R1 y R5. En enero y febrero se suman chinches y orugas, muchas veces en la misma pasada.",
          "El punto crítico: en soya densa de ciclo tardío el equipo terrestre ya entra pisando y abriendo callejones que son rendimiento perdido. El dron aplica parejo sin tocar una planta.",
        ],
        bullets: [
          "Monitoreo semanal desde R1, revisando el envés de la hoja",
          "Ventana típica de fungicida: R1 a R3, con refuerzo según presión",
          "Insecticida de choque cuando chinche supera el umbral de daño",
        ],
      },
      {
        heading: "Maíz y sorgo: el cogollero tiene ventana corta",
        body: [
          "El gusano cogollero ataca en las primeras fases (V3 a V6) y el control solo funciona si la gota llega al cartucho. Pasada esa ventana, el daño ya está hecho. En campaña de invierno (abril a agosto) el problema es otro: el lote puede estar barroso y el equipo terrestre simplemente no entra.",
          "La aplicación nocturna con dron aprovecha menos viento y menos deriva, y llega al cartucho sin pisotear surcos.",
        ],
        bullets: [
          "Control de cogollero entre V3 y V6: no esperar a ver el daño",
          "En invierno, el dron aplica aunque el suelo esté barroso",
          "Aplicación nocturna disponible para reducir deriva",
        ],
      },
      {
        heading: "Caña de azúcar: madurante a la altura justa",
        body: [
          "El madurante se aplica entre 30 y 45 días antes del corte, cuando la caña ya está alta y cerrada. A esa altura ningún equipo terrestre entra sin quebrar caña: es el caso de uso donde el dron no es una opción más, es la única aplicación que no daña el cultivo.",
          "La dosificación pareja por hectárea es lo que define la calidad del madurado: demasiado producto quema, poco producto no madura.",
        ],
      },
      {
        heading: "Girasol: proteger la floración",
        body: [
          "En la Chiquitania el girasol castiga sobre todo en floración: es el momento donde el cultivo define rendimiento y donde más sensibles son las abejas y el vuelo bajo. La aplicación foliar en floración tiene que ser pareja y sin aplastar plantas: el girasol es el cultivo que más agradece el vuelo bajo del dron.",
        ],
      },
      {
        heading: "Cómo coordinamos tu fecha",
        body: [
          "Escribinos por WhatsApp con cultivo, hectáreas y zona. Te devolvemos el precio por hectárea el mismo día y coordinamos la ventana según tu monitoreo. Cada vuelo cierra con ficha técnica firmada: hectáreas, litros por hectárea y dosis, por escrito.",
        ],
      },
    ],
    wa: "Hola Fumiga, leí el calendario de campaña 2026–27 y quiero coordinar la aplicación de mi cultivo.",
  },
  {
    slug: "normativa-drones-agricolas-bolivia",
    tag: "Normativa",
    date: "NOV 2026",
    title: "Qué dice (y qué no dice) Bolivia sobre drones agrícolas de gran porte",
    meta: "Estado real de la normativa para aplicación agrícola con drones en Bolivia: qué regula la DGAC, dónde entra SENASAG y qué preguntar antes de contratar un operador.",
    intro:
      "La pregunta seria de todo productor: ¿esto es legal y está regulado? Respuesta honesta: Bolivia tiene reglas para volar drones y reglas para aplicar fitosanitarios, pero todavía no una norma única que una las dos cosas. Te contamos qué está escrito, qué no, y cómo operamos nosotros.",
    sections: [
      {
        heading: "Lo que regula la DGAC: el vuelo",
        body: [
          "La Dirección General de Aeronáutica Civil es la autoridad del espacio aéreo boliviano. Sus reglas para aeronaves no tripuladas exigen operar de día o con autorización, lejos de aeródromos y zonas pobladas, y con responsable de la operación identificable. Los drones agrícolas de gran porte —los que cargan litros de caldo— entran en categorías que piden registro y autorización operativa.",
          "Traducción de campo: no es “comprar un dron y salir a volar”. El operador tiene que poder mostrarte su autorización y su registro.",
        ],
      },
      {
        heading: "Lo que regula SENASAG: el producto",
        body: [
          "El Servicio Nacional de Sanidad Agropecuaria regula los plaguicidas: qué productos están registrados, para qué cultivo y a qué dosis. Eso no cambia por aplicar con dron, con tractor o con mochila: el producto tiene que estar registrado y la dosis tiene que respetar la etiqueta.",
        ],
        bullets: [
          "Solo productos con registro SENASAG vigente",
          "Dosis por hectárea según etiqueta, nunca a ojo",
          "Respeto de franjas de protección: cursos de agua, colmenas y viviendas",
        ],
      },
      {
        heading: "Lo que dejamos por escrito",
        body: [
          "El operador serio se ordena por las normas que sí existen (vuelo y producto), documenta cada jornada por escrito y puede mostrarte su autorización antes de despegar.",
        ],
      },
      {
        heading: "Cómo operamos en Fumiga",
        body: [
          "Nuestro protocolo está armado para el día que la norma llegue: cada vuelo queda registrado con coordenadas, viento, litros por hectárea y producto aplicado, y el productor recibe una ficha técnica firmada al cierre de la jornada. Trabajamos con seguro de responsabilidad civil y con distancias de seguridad declaradas a poblados, agua y colmenas.",
        ],
        bullets: [
          "Registro de vuelo por lote, con fecha, hora y condiciones",
          "Ficha técnica firmada entregada al productor",
          "Franjas de protección declaradas antes de despegar",
        ],
      },
      {
        heading: "Qué preguntar antes de contratar a cualquier operador",
        body: [
          "Tres preguntas que separan al operador serio del improvisado: ¿me mostrás tu autorización de operación?, ¿qué seguro tenés?, ¿me entregás la ficha de aplicación por escrito? Si alguna respuesta es un rodeo, ahí no es.",
          "Este artículo es información general, no asesoría legal. Para tu caso concreto, consultá directamente con DGAC y SENASAG.",
        ],
      },
    ],
    wa: "Hola Fumiga, leí el artículo de normativa y quiero ver su protocolo y seguro antes de cotizar.",
  },
  {
    slug: "ficha-tecnica-aplicacion",
    tag: "Técnica",
    date: "DIC 2026",
    title: "Cómo leer una ficha técnica de aplicación: litros/ha, gota y deriva",
    meta: "Litros por hectárea, tamaño de gota y deriva explicados para el productor: por qué el dron aplica con menos agua sin perder efecto y qué tiene que decir la ficha firmada de tu aplicación.",
    intro:
      "Cuando un aplicador te dice “le puse 10 litros por hectárea” y el otro te dice “150”, suena a que el segundo trabajó mejor. No necesariamente. Acá va lo mínimo que tenés que saber para leer una ficha de aplicación y no pagar por agua de más ni por deriva de más.",
    sections: [
      {
        heading: "Litros por hectárea: el agua es el vehículo, no el efecto",
        body: [
          "El producto fitosanitario es lo que actúa; el agua solo lo lleva a la hoja. Un equipo terrestre mueve entre 100 y 200 litros por hectárea; un dron aplica entre 10 y 30 litros con la misma dosis de producto, más concentrada. Misma molécula, menos agua, misma hectárea cubierta.",
          "La clave está en la cobertura: con gota bien calibrada, menos litros no significan menos efecto. Significan menos tiempo de carga, menos traslado y aplicar aunque el lote esté barroso.",
        ],
      },
      {
        heading: "Tamaño de gota: el número que casi nadie pregunta",
        body: [
          "La gota fina cubre mejor pero deriva más; la gota gruesa deriva menos pero cubre peor. La elección depende del producto: un sistémico admite gota más gruesa; un fungicida de contacto para roya pide gota más fina y buena cobertura en el envés.",
          "En la ficha tiene que figurar el tipo de gota usado. Si no figura, preguntalo.",
        ],
        bullets: [
          "Gota fina: máxima cobertura, usar con poco viento",
          "Gota media: equilibrio cobertura–deriva, la más usada",
          "Gota gruesa: para herbicidas y condiciones de viento límite",
        ],
      },
      {
        heading: "Deriva: el costo que no se ve en la factura",
        body: [
          "La deriva es producto que se va del lote: no llega a tu planta y puede llegar al lote vecino. Se controla con tres variables: tamaño de gota, altura de vuelo y viento. Por eso la ficha debe registrar la velocidad del viento al momento de aplicar — con viento fuerte simplemente no se aplica, y un operador serio te lo dice y reprograma.",
          "El dron tiene una ventaja física acá: vuela a 2–3 metros del cultivo y el viento de los rotores empuja la gota hacia abajo. A menor altura, menos deriva.",
        ],
      },
      {
        heading: "Qué tiene que decir la ficha firmada",
        body: [
          "La ficha técnica es tu comprobante de que la aplicación se hizo y cómo se hizo. Si un día hay un reclamo —de un vecino, de un comprador de tu grano— la ficha es tu respaldo.",
        ],
        bullets: [
          "Cultivo, lote y hectáreas aplicadas, con fecha y hora",
          "Producto, dosis por hectárea y litros de caldo por hectárea",
          "Condiciones: viento, temperatura y humedad al aplicar",
          "Nombre y firma del responsable de la aplicación",
        ],
      },
      {
        heading: "La regla simple",
        body: [
          "No pagues por litros de agua: pagá por hectárea bien cubierta, con producto en dosis correcta y ficha firmada. Eso es lo que entregamos en cada vuelo de Fumiga — y es lo que tenés que exigirle a cualquier aplicador, con dron o sin dron.",
        ],
      },
    ],
    wa: "Hola Fumiga, leí el artículo de ficha técnica y quiero cotizar una aplicación con ficha firmada.",
  },
];
